// app/javascript/controllers/copy_example_sentence_controller.js
import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="copy-example-sentence"
export default class extends Controller {
  static targets = ["copyTo", "searchInput", "row", "cell", "count"];

  connect() {
    console.log("copyExampleSentence controller connected");
  }

  call(event) {
    const text = event.target.dataset.text;
    const copyToOriginalText = this.copyToTarget.value;
    this.copyToTarget.value = `${copyToOriginalText}${text}\n`;
  }

  filter() {
    const query = this.searchInputTarget.value.trim().toLowerCase();
    let visibleCount = 0;

    this.rowTargets.forEach((row) => {
      let rowHasMatch = false;

      row
        .querySelectorAll("[data-copy-example-sentence-target='cell']")
        .forEach((cell) => {
          const text = cell.dataset.text.toLowerCase();
          const matches = query === "" || text.includes(query);

          cell.closest("td").hidden = !matches;
          if (matches) {
            rowHasMatch = true;
            if (query !== "") visibleCount++;
          }
          this.highlight(cell, matches ? query : "");
        });

      row.hidden = !rowHasMatch;
    });

    if (this.hasCountTarget) {
      this.countTarget.textContent = query === "" ? "" : `${visibleCount}件`;
    }
  }

  highlight(cell, query) {
    const original = cell.dataset.text;
    if (query === "") {
      cell.textContent = original;
      return;
    }
    const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`(${escaped})`, "gi");
    cell.innerHTML = original.replace(regex, "<mark>$1</mark>");
  }
}
